import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Privateroutes from "./auth/Privateroutes";
import { ContextApi } from "../context/ContextApi";
import { useCookies } from "react-cookie";
// ========== pages ============
// Public
import Login from "./pages/public/Login";
import ForgetPass from "./pages/public/ForgetPass";
// Private
import Header from "./layouts/Header";
import Home from "./pages/home/Index";
import Transfers from "./pages/transfers/Index";
import Office from "./pages/office/Index";
import Shipment from "./pages/shipment/Index";
import { Spinner } from "react-bootstrap";

// ===================================================
const Details = () => {
  const { authentication, language, loading } = useContext(ContextApi);
  const [auth, setAuth] = authentication;
  const [lang, setLang] = language;
  const [cookies, setCookie, removeCookies] = useCookies();
  const role = localStorage.getItem("amar_management_role");
  // const [loader, setLoader] = loading;

  if (auth.isAuthenticated === null) {
    return (
      <div className="spiner d-flex flex-column align-items-center justify-content-center">
        <div className="page_loader">
          <Spinner animation="border" variant="warning" />
        </div>
      </div>
    );
  }

  return (
    <div className="details">
      <Router>
        <Header
          lang={lang}
          auth={auth}
          setAuth={setAuth}
          removeCookies={removeCookies}
        />
        <Routes>
          <Route element={<Privateroutes auth={auth.isAuthenticated} />}>
            <Route
              path="/"
              exact
              element={<Home lang={lang} cookies={cookies} />}
            />
            <Route path="/shipments" element={<Shipment lang={lang} />} />
            <Route path="/transfers" element={<Transfers lang={lang} />} />
            {role === "ADMIN" ? (
              <Route path="/office" element={<Office lang={lang} />} />
            ) : (
              <></>
            )}
          </Route>

          {!auth.isAuthenticated ? (
            <>
              <Route
                path="/login"
                element={<Login lang={lang} setAuth={setAuth} />}
              />
              <Route path="/forget-pass" element={<ForgetPass lang={lang} />} />
            </>
          ) : (
            <Route path="/login" element={<Navigate replace to="/" />} />
          )}
        </Routes>
      </Router>
    </div>
  );
};

export default Details;
